module.exports = __webpack_public_path__ + "static/img/16.9c3fa9c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/sp/16.png
// module id = UnAA
// module chunks = 0